import { useLang } from "hooks/useLang";
import VenueComponent from "./venueComponent";


const arr = [1, 2, 3, 4, 5, 6, 7, 8];

interface ICoordinates {
    lat: number;
    lng: number;
    _id: string;
}

export interface IVenue {
    _id: string;
    name_ar: string;
    name_en: string;
    slug: string;
    address_ar: string;
    address_en: string;
    city: string;
    country: string;
    coordinates: ICoordinates;
}


const renderVenuSection = (data: IVenue[]) => {
    return data.map((item) => <VenueComponent {...item} />)
}
const VenuesSection = ({ data, isLoading , showTitle=true}: { data: IVenue[] | any[], isLoading: boolean,showTitle?:boolean}) => {


    console.log("fromVenues",data)
    console.log("data",data)
    // const {data,isLoading}
    const { t } = useLang()

    if (isLoading) { return <></> }

    return <div className={`w-full flex flex-col px-4 ${ showTitle&& "py-8"} layout  md:max-w-[1220px]`}>
        {showTitle&&<h2 className="text-2xl font-bold mb-4 capitalize">{t("venues")}</h2>}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {renderVenuSection(data)}
    </div>
    </div>

};


export default VenuesSection